module.exports = __webpack_public_path__ + "static/assets/8497194d48884a70cb487a85803564d9.svg";